import React, { useState, useEffect } from "react";
import "./style.css";
import { installmentsModePayment } from "../../../constants/installmentsModePayment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select } from "antd";
import SingleInstallment from "./singleInstallment";
import { FormattedMessage, useIntl } from "react-intl";

const Option = Select.Option;

const RecurrentPaymentForm = ({
  paymentDetails,
  setPaymentDetails,
  ibanError,
  onChangeIban,
  setInstallments,
  installments,
  installmentsError,
  setInstallmentsError,
  isEdit,
  address,
  installmentsToEdit,
  setInstallmentsToEdit
}) => {
  const [isInstallmentsErrorVisible, setIsInstallmentsErrorVisible] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    const installmentsToIterate = !isEdit ? installments : installmentsToEdit;
    const amounts = installmentsToIterate.map(i => parseFloat(i.amount));
    const sum = amounts.reduce((a, b) => a + b, 0);
    const roundedSum = Math.round(sum * 100) / 100;
    setInstallmentsError(Math.round(roundedSum) !== 100 ? true : false);
  }, [installments, installmentsToEdit]);

  useEffect(() => {
    setIsInstallmentsErrorVisible(installmentsError);
  }, [installments, installmentsToEdit, installmentsError]);

  useEffect(() => {
    const installments = address?.negotiatedPaymentPlans?.[0]?.installments;
    if (installments) {
      const installmentsForFe = installments?.map(i => {
        return {
          dueDate: {
            number: i.dueDate.days,
            interval: "giorni",
            from:
              i.dueDate.from === "DOCUMENT_DATE_END_OF_MONTH"
                ? "month-end"
                : "invoice"
          },
          amount: i.fractionOver10K / 100,
          iban: "",
          paymentMethod: i.paymentMethods[0]
        };
      });
      setInstallmentsToEdit([...installmentsForFe]);
    }
  }, [address]);

  const renderPaymentType = () => {
    const items = installmentsModePayment.map((item, index) => {
      return (
        <Option value={item.key} key={index}>
          {item.desc}
        </Option>
      );
    });
    return items;
  };

  const onChangeValueIban = e => {
    setPaymentDetails({ ...paymentDetails, iban: e.target.value });
    onChangeIban(e);
  };

  const renderInstallments = () => {
    const installmentsToIterate = !isEdit ? installments : installmentsToEdit;
    const installmentRow = installmentsToIterate.map((x, index) => {
      return (
        <SingleInstallment
          key={`installmentsToIterate_${index}`}
          num={index + 1}
          index={index}
          setInstallments={isEdit ? setInstallmentsToEdit : setInstallments}
          installments={installmentsToIterate}
          renderPaymentType={renderPaymentType}
          onChangeValueIban={onChangeValueIban}
          ibanError={ibanError}
          installmentsToEdit={installmentsToEdit}
        />
      );
    });
    return installmentRow;
  };

  return (
    <>
      <div className="payment-form-header">
        <div className="payment-form-header-title">{intl.formatMessage({ id: "addressBook.payments"})}</div>
        <div className="payment-form-subtitle-switcher"></div>
      </div>
      <div className="payment-form-body">
        {renderInstallments()}
        {isInstallmentsErrorVisible && (
          <div className="registry-form-installments-error">
            <div>
              <FontAwesomeIcon
                icon={["fas", "exclamation-circle"]}
                style={{ marginRight: "10px", color: "#fc4e3d" }}
              />
              <FormattedMessage id="parties.installmentsError" />
            </div>
            <FontAwesomeIcon
              icon={["far", "times"]}
              style={{ marginRight: "10px", cursor: "pointer" }}
              onClick={() => setIsInstallmentsErrorVisible(false)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RecurrentPaymentForm;
